<template>
  <div class="main">
    <!-- 导航栏部分 -->
    <div class="nav">
      <van-nav-bar
        title="电子健康卡注册(2/2)"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <van-form>
      <van-field
        v-model="questionForm.phone1"
        name="手机号"
        placeholder="手机号"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" @click="submit"
          >完成注册</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import Nav from "../ElectronicHealthCard/components/nav.vue";
export default {
  data() {
    return {
      questionForm: {
        wechatCode: "",
        gender: "",
        nation: "",
        name: "",
        address: "",
        birthday: "",
        idNumber: "",
        phone1: "",
        phone2: "",
        patid: "",
        idType: "",
        cityCode: "",
        relation: "",
      },
    };
  },
  mounted() {
    // 获取上个页面传递过来的参数
    this.questionForm = this.$route.params.questionForm;
  },
  methods: {
    // 返回上一个页面
    onClickLeft() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        this.$showLoad();
        let url = "/healthcardcontroller/registerHealthCard";
        let reques_data = {
          wechatCode: this.questionForm.wechatCode,
          gender: this.questionForm.gender,
          nation: this.questionForm.nation,
          name: this.questionForm.name,
          address: this.questionForm.address,
          birthday: this.questionForm.birthday,
          idNumber: this.questionForm.idNumber,
          phone1: this.questionForm.phone1,
          phone2: this.questionForm.phone2,
          patid: this.questionForm.patid,
          idType: "01",
          cityCode: this.questionForm.cityCode,
          relation: this.questionForm.relation,
          pid: this.questionForm.patid,
        };
        // alert(JSON.stringify(reques_data))
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reques_data,
          (data) => {
            this.$hideLoad();
            this.$toast.fail("注册成功");
            if (data.status == 200) {
              this.$router.push({
                path: "/HealthcardList",
                query: {
                  clientId: data.data.data.rsp.pid,
                },
              });
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("身份绑定失败, 请核对绑定信息重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  width: 100%;
  height: 100%;
  background-color: #cccc;
}
</style>
